export default angular.module('gm.wealth.common')
  .directive('gmwMatches', gmwMatches)
  .name;

function gmwMatches() {
  'ngInject';

  const directive = {
    link,
    restrict: 'A',
    require: 'ngModel',
  };
  return directive;

  function link(_scope, _element, attrs, ctrl) {
    ctrl.$validators.matches = modelValue =>
      (modelValue ? (modelValue === attrs.gmwMatches) : true);
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/directives/matches/matches.js